module.exports = {
  controller: require('./working-hours.ctrl')
  template: require('./working-hours.pug')()
  bindings:
    salon: '<'
    onSubmit: '&'
}
